import React, { useState } from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import { useAuth } from '@templatean/shared/hooks'
import { storageService } from '@templatean/shared/services'

const SettingsPage: React.FC = () => {
  const { user, logout } = useAuth()
  const [preferences, setPreferences] = useState({
    autoSave: true,
    showTemplateHints: true,
    defaultView: 'grid',
    aiModel: 'gpt-4'
  })

  const handleSavePreferences = async () => {
    await storageService.saveUserPreferences(preferences)
    alert('Preferences saved!')
  }

  const handleLogout = async () => {
    if (confirm('Are you sure you want to sign out?')) {
      await logout()
    }
  }

  return (
    <AppContainer>
      <Header 
        title="Settings"
        subtitle="Configure your preferences"
      />
      
      <div className="page-content settings-page">
        <section className="settings-section">
          <h2>Account</h2>
          <div className="settings-info">
            <p><strong>Name:</strong> {user?.fullName}</p>
            <p><strong>Email:</strong> {user?.email}</p>
            <p><strong>Tenant:</strong> {user?.tenantId}</p>
          </div>
          <button onClick={handleLogout} className="btn btn-secondary">
            Sign Out
          </button>
        </section>

        <section className="settings-section">
          <h2>Preferences</h2>
          
          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.autoSave}
                onChange={(e) => setPreferences({
                  ...preferences,
                  autoSave: e.target.checked
                })}
              />
              <span>Auto-save documents</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.showTemplateHints}
                onChange={(e) => setPreferences({
                  ...preferences,
                  showTemplateHints: e.target.checked
                })}
              />
              <span>Show template hints</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              Default View:
              <select
                value={preferences.defaultView}
                onChange={(e) => setPreferences({
                  ...preferences,
                  defaultView: e.target.value
                })}
                className="preference-select"
              >
                <option value="grid">Grid</option>
                <option value="list">List</option>
              </select>
            </label>
          </div>

          <div className="preference-item">
            <label>
              AI Model:
              <select
                value={preferences.aiModel}
                onChange={(e) => setPreferences({
                  ...preferences,
                  aiModel: e.target.value
                })}
                className="preference-select"
              >
                <option value="gpt-4">GPT-4</option>
                <option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
                <option value="claude-3">Claude 3</option>
              </select>
            </label>
          </div>

          <button onClick={handleSavePreferences} className="btn btn-primary">
            Save Preferences
          </button>
        </section>

        <section className="settings-section">
          <h2>About</h2>
          <p>Templatean for Word v1.0.0</p>
          <p>© 2024 Templatean Corporation</p>
          <p>
            <a href="https://templatean.com/help" target="_blank">
              Help & Documentation
            </a>
          </p>
        </section>
      </div>
    </AppContainer>
  )
}

export default SettingsPage